"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.simplifyPath = void 0;
/**
 * Упрощает path
 *
 * Если в настройке http.path-simplify-prefixes есть сооветствие начала path,
 * то возвращает найденый префикс + "x"
 *
 * Удаляет части path, состоящие только из чисел, заменяя на символ "d"
 *
 * @export
 * @param {string} path
 * @return {*} {string}
 */
function simplifyPath(path, config) {
    var e_1, _a;
    var simplifyPrefixes = (config === null || config === void 0 ? void 0 : config.get('http.path-simplify-prefixes')) || [];
    var spanName = path.toLocaleLowerCase();
    try {
        for (var simplifyPrefixes_1 = __values(simplifyPrefixes), simplifyPrefixes_1_1 = simplifyPrefixes_1.next(); !simplifyPrefixes_1_1.done; simplifyPrefixes_1_1 = simplifyPrefixes_1.next()) {
            var prefix = simplifyPrefixes_1_1.value;
            if (spanName.startsWith(prefix)) {
                return "".concat(prefix, "x");
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (simplifyPrefixes_1_1 && !simplifyPrefixes_1_1.done && (_a = simplifyPrefixes_1.return)) _a.call(simplifyPrefixes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // Для удаления можно было бы использовать регулярку /(?<=\/)\d+(?=\/)/g
    // но positive lookbehind не поддерживается safari
    return path
        .toLocaleLowerCase()
        .split('/')
        .map(function (part) { return part.replace(/^\d+$/, 'd'); })
        .join('/');
}
exports.simplifyPath = simplifyPath;
//# sourceMappingURL=simplifyPath.js.map